// noinspection JSUnusedGlobalSymbols
import LoadingDisplay from "@phmg/apis/src/js/LoadingDisplay.js";

const LoadingDisplayClass = LoadingDisplay;
const HiveInterface = window.Hive || {};
HiveInterface.getLoadingDisplay = () => LoadingDisplayClass;
window.Hive = HiveInterface;
